const pad = (n: number) => n.toString().padStart(2, "0");

export const isoToLocalInput = (
  iso: string | Date | undefined | null,
): string => {
  if (!iso) return "";
  const d = new Date(iso as string);
  if (Number.isNaN(d.getTime())) return "";
  return (
    `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}` +
    `T${pad(d.getHours())}:${pad(d.getMinutes())}`
  );
};

export const localInputToIso = (local: string): string | undefined => {
  if (!local) return undefined;
  const d = new Date(local);
  if (Number.isNaN(d.getTime())) return undefined;
  return d.toISOString();
};

export const isoFromHoursFromNow = (hours: number): string => {
  const d = new Date(Date.now() + hours * 60 * 60 * 1000);
  return d.toISOString();
};
